import { requestJson } from "../api/apiClient";

export async function fetchDealerProfiles(filters = {}) {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(filters)) {
    if (value != null && value !== "") {
      params.set(key, String(value));
    }
  }
  const query = params.toString();
  return requestJson(`/api/admin/automotive/dealer-profiles${query ? `?${query}` : ""}`);
}

export async function updateDealerProfile(profileKey, payload) {
  const response = await requestJson(
    `/api/admin/automotive/dealer-profiles/${encodeURIComponent(profileKey)}`,
    {
      method: "PATCH",
      body: JSON.stringify(payload),
    }
  );
  return response.profile || response;
}
